import React from 'react';
import { KundaliHero } from '../components/kundali/KundaliHero';
import { NavBar } from '../components/kundali/NavBar';
import { AboutSection } from '../components/kundali/AboutSection';
import { AllServices } from '../components/kundali/AllServices';
import { SocialProof } from '../components/kundali/SocialProof';
import { ConsultationServices } from '../components/kundali/ConsultationServices';
import { FAQ } from '../components/kundali/FAQ';
import { TrustSection } from '../components/kundali/TrustSection';
import { CTASection } from '../components/kundali/CTASection';
import { StickyMobileCTA } from '../components/kundali/StickyMobileCTA';
import { ChatWidget } from '../components/kundali/ChatWidget';
import { useEffect } from 'react';

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0000] font-['Outfit'] text-white overflow-hidden">
      {/* Decorative ambient glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          background:
            'radial-gradient(circle at 15% 10%, rgba(212,175,55,0.06) 0%, transparent 40%), radial-gradient(circle at 85% 80%, rgba(123,30,43,0.08) 0%, transparent 45%)'
        }}
      />

      <NavBar />

      <div className="relative z-10">
        <KundaliHero />
        <div id="about" className="scroll-mt-20"><AboutSection /></div>
        <div className="scroll-mt-20"><AllServices /></div>
        <div id="testimonials" className="scroll-mt-20"><SocialProof /></div>
        <ConsultationServices />
        <div id="faq" className="scroll-mt-20"><FAQ /></div>
        <TrustSection />
        <div id="contact" className="scroll-mt-20"><CTASection /></div>
      </div>

      <StickyMobileCTA />
      <ChatWidget />
    </div>
  );
};

export default LandingPage;
